import type { UseFormReturn } from "react-hook-form"
import type { COLUMN } from "../types/form-types"
import { Field } from "./field"

interface ColumnProps {
	form: UseFormReturn
	column: COLUMN
}

export const Column = ({ column, form }: ColumnProps) => {
	return (
		<div className="space-y-4">
			{column.fields.map(field => (
				<Field
					field={field}
					key={field.field_id}
					form={form}
				/>
			))}
		</div>
	)
}
